import styles from "./Header.module.scss";
import {ROUTES} from "../../constants/routes";
import {useTranslation} from "react-i18next";
import {useLogin} from "../../hooks/useLogin";
import {useAppSelector} from "../../store/store";
import {useRef} from "react";
import useOutsideClick from "../../utils/hooks/useOutsideClick";
import headerAvatar from "../../static/imgs/headerAvatar.png";
import StarDropdownIcon from "../icons/StarDropdownIcon";
import {setAccountTab} from "../../store/slices/navigation.slice";
import {useDispatch} from "react-redux";
import {getUserImageUrl} from "../../utils/imageUrl";
import {getLatestSubscriptionEndDate, formatSubscriptionDate} from "../../utils/subscription";

interface IProps {
  goToPage: (page: string) => void;
  openDropHandler: () => void
  opened: boolean;
}

const AccountDropDown = ({ goToPage, openDropHandler, opened }: IProps) => {
  const {t, i18n} = useTranslation();
  const userData = useAppSelector((state: any) => state.auth.userData);
  const firstName = userData?.username;
  const userId = userData?.hashed_id;
  const userAvatarUrl = getUserImageUrl(userData?.picture_url);
  const hasPremium = Boolean(userData?.has_monthly_subscription || userData?.has_yearly_subscription);
  const premiumEndDate = hasPremium ? formatSubscriptionDate(getLatestSubscriptionEndDate(userData)) : "";


  const dispatch = useDispatch();
  const { logout } = useLogin();

  const modalRefAcc = useRef<HTMLDivElement>(null);
  useOutsideClick(modalRefAcc, openDropHandler);

  const dirData = i18n.language === 'ar' ? 'rtl' : 'ltr'

  return (
    <div
      dir={dirData}
      ref={modalRefAcc}
      className={`${styles.accountDropDown} ${opened ? styles.openedAcc : ''}`}
    >
      <div className={styles.accDropSectionWrapper}>
        <div className={styles.userName}>
          <div className={`${styles.headerProfileDrop}`}>
            <img src={userAvatarUrl || headerAvatar} alt="avatar"/>
            {!userAvatarUrl && <span>{(firstName || 'U')[0]}</span>}
          </div>
          <div className={styles.accDropName}>{firstName || 'User'}</div>
        </div>
        <div className={styles.accId}>Hiviewer ID: {userId}</div>
        <div
          onClick={() => {
            dispatch(setAccountTab(1))
            goToPage(ROUTES.PROFILE)
          }}
          className={styles.accDropMenu}>{t('subAndPay')}</div>
        <div
          onClick={() => {
            dispatch(setAccountTab(2))
            goToPage(ROUTES.PROFILE)
          }}
          className={`${styles.accDropMenu}`}>{t('settings')}</div>
      </div>
      {hasPremium ? (
        <div className={styles.plans}>
          <>
            <StarDropdownIcon />
            {t('premiumName')}

            {premiumEndDate ? (
              <>
                {' '}
                <span className={styles.accDropSmallText}>
                  {t('premiumValidUntilHeader')}
                  {' '}
                  {premiumEndDate}
                </span>
              </>
            ) : (
              <> {t('premiumActive')}</>
            )}
          </>
        </div>
      ) : (
        <div
          onClick={() => {
            goToPage(ROUTES.DISCOUNT)
          }}
          className={styles.plans}
        >
          <StarDropdownIcon />{t('tar')}
        </div>
      )}
      <div
        onClick={() => {
          logout();
          openDropHandler();
          goToPage(ROUTES.FOR_YOU);
        }}
        className={styles.signOut}
      >
        {t('logOut')}
      </div>
    </div>
  )
}

export default AccountDropDown;
